import { useQuery } from '@apollo/client';
import {
  LenderActivityByCountryQueryResponse,
  LenderActivityByDealerQueryResponse,
  LenderActivityByDeclineReasonQueryResponse,
  LenderActivityByLenderQueryResponse,
  LenderActivityByStateQueryResponse,
  LenderActivitySummaryQueryResponse,
} from '../api/types';
import { lenderActivityDashboardApi } from '../api';
import { LenderAppsSorting, LenderRetailActivityReportInput } from '../types';

export const useLenderActivityDashboard = (
  input: LenderRetailActivityReportInput,
  lenderSorting?: LenderAppsSorting
) => {
  const variables = { input };
  const context = { authRequired: true };

  const { data: summaryData, loading: isSummaryLoading } = useQuery<LenderActivitySummaryQueryResponse>(
    lenderActivityDashboardApi.getSummary,
    { variables, context }
  );

  const { data: countryData, loading: isCountryLoading } = useQuery<LenderActivityByCountryQueryResponse>(
    lenderActivityDashboardApi.getByCountry,
    { variables, context }
  );

  const { data: lenderData, loading: isLenderLoading } = useQuery<LenderActivityByLenderQueryResponse>(
    lenderActivityDashboardApi.getByLender,
    { variables: { input: lenderSorting ? { ...input, sorting: lenderSorting } : input }, context }
  );

  const { data: stateData, loading: isStateLoading } = useQuery<LenderActivityByStateQueryResponse>(
    lenderActivityDashboardApi.getByState,
    { variables, context }
  );

  const { data: dealerData, loading: isDealerLoading } = useQuery<LenderActivityByDealerQueryResponse>(
    lenderActivityDashboardApi.getByDealer,
    { variables, context }
  );

  const { data: declineReasonData, loading: isDeclineReasonLoading } =
    useQuery<LenderActivityByDeclineReasonQueryResponse>(lenderActivityDashboardApi.getByDeclineReason, {
      variables,
      context,
    });

  const dealerEntity = dealerData?.lenderRetailActivity?.byDealer?.entity ?? null;

  return {
    summary: summaryData?.lenderRetailActivity?.summary?.entity ?? null,
    byCountry: countryData?.lenderRetailActivity?.byCountry?.entity ?? [],
    byLender: lenderData?.lenderRetailActivity?.byLender?.entity ?? [],
    byState: stateData?.lenderRetailActivity?.byState?.entity ?? [],
    byDealer: dealerEntity?.dealers ?? [],
    dealerTotals: { totalCreditApps: dealerEntity?.totalCreditApps ?? 0, totalUnits: dealerEntity?.totalUnits ?? 0 },
    byDeclineReason: declineReasonData?.lenderRetailActivity?.byDeclineReason?.entity ?? [],
    isSummaryLoading,
    isCountryLoading,
    isLenderLoading,
    isStateLoading,
    isDealerLoading,
    isDeclineReasonLoading,
  };
};
